export default (model, id) => {
  const fields = model.fields();
  const values = {};
  const item = model.find(id);
  for (const field in fields) {
    if (field !== "id") {
      values[field] = item ? item[field] : undefined;
    }
  }
  return values;
};
